import { Back } from './Back';
import { Next } from './Next';

export default {
  Back,
  Next
}
